<mat-toolbar class="footer">
    <span>
        <i class="material-icons v-middle" appRed>
            forward
        </i>
        contato: 
        <strong>compliance@mpconstrucao.pt</strong>
        <mat-progress-bar mode="buffer" color="primary"></mat-progress-bar>
    </span>
</mat-toolbar>